import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataService } from '../../../@core/services/data.service';
import { PricingPlanModel } from '../../../@core/models/pricing-plan.model';
import { PricingInterface } from '../../../@core/models/site-material-data.model';
import { GoogleAnalyticsService } from '../../../@core/services/google-analytics.service';
import { AnalyticsService } from '../../../@core/services/analytics.service';
import * as Sentry from "@sentry/browser";


@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialPricingComponent implements OnInit {

  title: string;
  subTitle: string;
  subTitleColor: string;
  titleSize: string;
  titleColor: string;
  textColor: string;
  fontWeight: string;
  titleInputValue: string;
  backgroundColor: string;
  features: string[];
  plans: PricingPlanModel[];
  activatePadding: boolean = true;
  availableFeatures: Array<Array<string>> = [];
  customAvailableFeatures: Array<Array<string>> = [];
  unavailableFeatures: Array<Array<string>> = [];
  data: PricingInterface;
  position: number = 0;
  moduleInfo: string;
  pricingOption: boolean = true;
  monthPricePerYear: boolean = false;
  hideSwitcher: boolean = false;
  loading: boolean = true;
  allElementAnimation: string;
  textAnimation: string;
  itemsAnimation: string;

  constructor(private dataService: DataService, private analyticsService: AnalyticsService, private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.itemsAnimation = this.data.animation.items != '' ? this.data.animation.items : undefined;

    }
    this.loading = false;
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "PricingComponent");
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.title = this.data.title;
    this.titleInputValue = this.data.title;
    this.subTitle = this.data.subTitle;
    this.subTitleColor = this.data.subTitleColor;
    this.fontWeight = this.data.fontWeight;
    this.features = this.data.features;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.plans = this.data.plans;
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.data.textColor;
    this.textColor = this.data.textColor ? this.data.textColor : this.dataService.getDefaultColor(this.backgroundColor);
    this.plans.forEach(plan => {
      if (plan.hideSwitcher) {
        this.hideSwitcher = true;
      }
      if (plan.monthPricePerYear) {
        this.monthPricePerYear = true;
      }
    });
    this.checkAvailableFeatures(this.features, this.plans);
    this.plans = this.plans.map(plan => {
      if (isNaN(Number(plan.costMonthly))) {
        plan.costMonthly = '';
      }
      if (isNaN(Number(plan.costYearly))) {
        plan.costYearly = '';
      }
      return plan;
    });
  }
  checkAvailableFeatures(features: string[], plans: PricingPlanModel[]): void {
    for (let i = 0; i < plans.length; i++) {
      let customFeatures = plans[i].availableFeatures.filter(feature => {
        if (features && features.includes(feature)) {
          return false;
        } else {
          return true;
        }
      });
      let available = [];
      let unavailable = [];
      features.forEach((feature) => {
        if (plans[i].availableFeatures && plans[i].availableFeatures.includes(feature)) {
          available.push(feature);
        } else {
          unavailable.push(feature);
        }
      });
      this.availableFeatures.push(available);
      this.unavailableFeatures.push(unavailable);
      if (customFeatures.length > 0) {
        this.customAvailableFeatures.push(customFeatures);
      };
    }
  }
  planClicked(plan: PricingPlanModel) {
    const currentSite = this.dataService.site$.getValue();
    if (currentSite) {
      this.analyticsService.trackConversion(currentSite, 'click');
    }
    if (currentSite.googleAnalyticsPixel) {
      this.googleAnalyticsService.eventEmitter('begin_checkout', 'begin_checkout_subscription', 'begin_checkout' + plan.planName.toLocaleLowerCase().replace(' ', '_'), 'ecommerce', plan.costYearly, [plan.planName.toLocaleLowerCase().replace(' ', '_')], plan.currency);
    }
    if (currentSite.facebookPixel) {
      this.googleAnalyticsService.FbEventEmitter('BeginCheckout', 'product', 'BeginCheckout ' + plan.planName.toLocaleLowerCase().replace(' ', '_'), 'ecommerce', plan.costYearly, plan.planName.toLocaleLowerCase().replace(' ', '_'), 1);
    }
  }
  getDiscountValue(promotionalCost,Cost){
    return 100-((promotionalCost*100)/Cost);
  }

}
